<template>
  <v-data-table
    dense
    class="elevation-1"
    color="primary"
    :calculate-widths="true"
    :no-data-text="noDataWarn"
    :headers="headers"
    :items="tblItems"
    :search="search"
    :expanded.sync="expanded"
    :single-expand="singleExpand"
    show-expand
    :footer-props="footerProps"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title class="text-body-2 font-weight-bold">{{
          tableTitle
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          hide-details
          :label="searchPrompt"
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.index="{ item }">
      <span>{{ item.index + 1 }}</span>
    </template>
    <template v-slot:item.total="{ item }">
      <span class="text-caption"
        >${{ formatDecimal(getInvoiceTotal(item.codigo)) }}</span
      >
    </template>
    <template v-slot:item.tipo="{ item }">
      <span class="text-caption" :class="getItemTipoFieldClass(item)">
        {{ getItemTipoColTitle(item) }}
      </span>
    </template>

    <template v-slot:item.fecha="{ item }">
      <span>{{ getTimeStr(item.fecha) }}</span>
    </template>
    <template v-slot:item.monto="{ item }">
      <span class="font-weight-bold" :class="getItemMontoFieldClass(item)">
        ${{ formatDecimal(item.monto) }}
      </span>
    </template>
    <template v-slot:item.saldo="{ item }">
      <span class="text-caption">${{ formatDecimal(item.saldo) }}</span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td style="text-align: center" :colspan="headers.length">
        <div style="display: flex; justify-content: center">
          <div style="display: flex">
            <div style="margin-right: 5px">
              <strong>{{ expandConceptTitle }}</strong>
            </div>
            <div>
              {{ getExpandedItemConcept(item) }}
            </div>
          </div>
          <v-divider
            class="mx-4"
            vertical
            v-if="dataDescription == 'cobros'"
          ></v-divider>
          <div style="display: flex" v-if="dataDescription == 'cobros'">
            <div style="margin-right: 5px">
              <strong>Saldo Anterior:</strong>
            </div>
            <div>
              {{ getInvoiceSaldoAnterior(item) }}
            </div>
          </div>
          <template v-if="dataDescription == 'cobros'">
            <v-divider class="mx-4" vertical></v-divider>
            <div style="display: flex; justify-content: center">
              <div style="margin-right: 5px">
                <strong>Denominacion: </strong>
              </div>
              <div>${{ item.denominacion }}</div>
            </div>
          </template>
        </div>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import * as Utils from "../../services/utils";
//placed in the window object by the preload and available in the global context
// const { getUsuarioByID } = api.services.usuariosService;
// const { getClienteByID } = api.services.clientesService;
// const { getSaleById } = api.services.ventasService;
// const { getCobrosByInvoiceID } = api.services.cajaService;

export default {
  name: "MovimientosCajaTbl",
  props: {
    dataDescription: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    tableTitle: {
      type: String,
      required: true,
    },
    searchPrompt: {
      type: String,
      required: true,
    },
    noDataWarn: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      search: "",
      expanded: [],
      footerProps: {
        "items-per-page-text": "Filas a mostrar",
      },
      singleExpand: true,
    };
  },
  computed: {
    tblItems() {
      return [...this.items].reverse();
    },
    expandConceptTitle() {
      return this.dataDescription == "cobros" ? "Tipo de Pago:" : "Concepto:";
    },
  },
  methods: {
    getUsuarioByID(){},
    getClienteByID(){},
    getSaleById(){},
    getCobrosByInvoiceID(){},
    getItemMontoFieldClass(item) {
      if (item.tipo == "retiro") {
        switch (item.concepto) {
          case "tarjeta":
          case "deposito_bancario":
          case "transferencia_inter_bancaria":
            return "red--text text--lighten-3";
          default:
            return "red--text text--darken-4";
        }
      } else if (item.tipo == "deposito") {
        return "green--text text--darken-4";
      }
      return "teal--text text--darken-2";
    },
    getItemTipoFieldClass(item) {
      if (item.tipo == "retiro") {
        switch (item.concepto) {
          case "tarjeta":
          case "deposito_bancario":
          case "transferencia_inter_bancaria":
            return "red--text text--lighten-3";

          default:
            return "red--text text--darken-4";
        }
      }
      return "green--text text--darken-4";
    },
    getItemTipoColTitle(item) {
      if (this.isAutomaticWithDrawal(item)) {
        return "auto-retiro";
      }
      return item.tipo;
    },
    getExpandedItemConcept(item) {
      console.log(item);
      // switch (item.concepto && this.isAutomaticWithDrawal(item)) {
      //   case true:
      //     const concepto = item.concepto.split("_").join(" ");
      //     const folio = item.codigo ? item.codigo : "";
      //     return `Pago con ${concepto}, Folio: ${folio}`;
      //   case false:
      //     return item.concepto;
      //   default:
      //     return `${item.tipo} en efectivo`;
      // }
    },
    isAutomaticWithDrawal(item) {
      const formasDePago = [
        "deposito_bancario",
        "transferencia_inter_bancaria",
        "tarjeta",
      ];
      return formasDePago.includes(item.concepto);
    },
    getTimeStr(dateStr) {
      const date = new Date(dateStr);
      const str = date.toTimeString();
      return str.substr(0, 5);
    },
    getNombreCliente(idCliente) {
      const cliente = this.getClienteByID(idCliente);
      return `${cliente.nombre} ${cliente.apellido}`;
    },
    getNombreCajero(idUsuario) {
      const usuario = this.getUsuarioByID(idUsuario);
      return usuario.nombre;
    },
    getInvoiceTotal(codigo) {
      const invoice = this.getSaleById(codigo);
      return invoice ? parseFloat(invoice.total) : -1;
    },
    getInvoiceSaldoAnterior(item) {
      const cobros = this.getCobrosByInvoiceID(item.codigo);
      const movimientosAnteriores = cobros.filter(
        (cobro) => cobro.id < item.id
      );
      const prevIDX =
        movimientosAnteriores.length >= 1
          ? movimientosAnteriores.length - 1
          : movimientosAnteriores.length;
      const movimientoAnterior = movimientosAnteriores[prevIDX];

      const invoiceTotal = this.getInvoiceTotal(item.codigo);
      const saldoAnterior =
        movimientoAnterior && movimientoAnterior.saldo
          ? `$${parseFloat(movimientoAnterior.saldo.toFixed(2))}`
          : `$${parseFloat(invoiceTotal).toFixed(2)}`;
      return saldoAnterior;
    },
    formatDecimal(num) {
      return Utils.formatDecimal(num);
    },
  },
};
</script>
